/* M.Bren: free-shipping bar + mobile sticky add-to-cart. No external requests, no tracking, reads only the cart total. */
(function(){
  function fmt(n){return Math.round(n/100)+' ₪'}
  /* The bar always reflects the REAL cart total. The product price is only used in the wording, never to mark free shipping as reached. */
  function paint(el,cart){
    var th=+el.dataset.threshold, add=+el.dataset.add||0, mode=el.dataset.mode;
    var left=th-cart, done=left<=0, t=el.querySelector('.mbren-ship__t'), f=el.querySelector('.mbren-ship__fill');
    el.hidden=(mode==='cart'&&cart===0);
    f.style.width=Math.min(100,Math.round(cart/th*100))+'%';
    el.classList.toggle('is-done',done);
    var txt;
    if(done){txt='איזה כיף! הגעת למשלוח חינם! 🥳'}
    else if(mode==='cart'){txt='נשאר רק עוד '+fmt(left)+' למשלוח חינם! 🚛'}
    else if(cart===0){
      if(add>=th){txt='הסט הזה לבדו מזכה במשלוח חינם! 🚛'}
      else{txt='עם הסט הזה נשאר רק עוד '+fmt(th-add)+' למשלוח חינם! 🚛'}
    }
    else{txt='נשאר רק עוד '+fmt(left)+' למשלוח חינם! 🚛'; if(add>=left) txt+='\nהוסף פריט זה לקבלת משלוח חינם'}
    t.textContent=txt;
  }
  function drawerBar(){
    var foot=document.querySelector('#CartDrawer .cart-drawer__footer');
    if(!foot||foot.querySelector('.mbren-ship')) return;
    var b=document.createElement('div');
    b.className='mbren-ship'; b.dataset.threshold='29900'; b.dataset.add='0'; b.dataset.mode='cart'; b.setAttribute('role','status');
    b.innerHTML='<div class="mbren-ship__t"></div><div class="mbren-ship__track"><div class="mbren-ship__fill"></div></div>';
    var totals=foot.querySelector('.totals'); foot.insertBefore(b,totals||null);
  }
  function refresh(){
    drawerBar();
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){
      document.querySelectorAll('.mbren-ship').forEach(function(el){paint(el,c.total_price)});
    }).catch(function(){});
  }
  /* Hide the floating cookie-preferences button (it covers the WhatsApp bubble). The consent banner itself is untouched. */
  function hideCookieWidget(){
    var tries=0, iv=setInterval(function(){
      var host=document.querySelector('pandectes-cmp'), root=host&&host.shadowRoot;
      if(root){
        var hide=function(){var w=root.querySelector('button.widget'); if(w) w.style.setProperty('display','none','important')};
        hide();
        if('MutationObserver' in window) new MutationObserver(hide).observe(root,{childList:true,subtree:true});
        clearInterval(iv); return;
      }
      if(++tries>40) clearInterval(iv);
    },500);
  }
  function init(){
    hideCookieWidget();
    document.querySelectorAll('.mbren-ship').forEach(function(el){paint(el,+el.dataset.cart||0)});
    refresh();
    var dr=document.querySelector('cart-drawer'); if(dr&&'MutationObserver' in window){new MutationObserver(function(){if(!document.querySelector('#CartDrawer .cart-drawer__footer .mbren-ship')) refresh()}).observe(dr,{childList:true,subtree:true})}
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){subscribe(PUB_SUB_EVENTS.cartUpdate,function(){setTimeout(refresh,300)})}
    document.querySelectorAll('.mbren-sticky').forEach(function(bar){
      var form=document.getElementById(bar.dataset.form); if(!form) return;
      var real=form.querySelector('[type="submit"]'); if(!real||!('IntersectionObserver' in window)) return;
      var io=new IntersectionObserver(function(es){var e=es[0];
        bar.hidden=e.isIntersecting||e.boundingClientRect.top>0;
      });
      io.observe(real);
      bar.querySelector('button').addEventListener('click',function(){real.click()});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
